/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { setApplicationLocalStorageItem } from "../helpers";
import state from "./state";
import { performFetch } from '../helpers'

const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit("UPDATE_STARRED_PAGE", payload);
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_LIMITED", list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_MORE", list);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit("TOGGLE_CONTENT_OVERLAY");
  },
  updateTheme({ commit }, val) {
    commit("UPDATE_THEME", val);
  },
  async updateLayoutSettings({ commit, dispatch }, payload) {
    const current_layout = state.auth.layout;
    setApplicationLocalStorageItem("layout", JSON.stringify(current_layout));

    // await fetch(`${state.auth.api_url}`, {
    //   method: "POST", headers: {"Content-Type": "application/json"},
    //   body: JSON.stringify({
    //     command: "update_user_layout",
    //     parameters: {
    //       application_token: state.auth.app_token,
    //       session_token: state.auth.token,
    //       layout: current_layout
    //     }
    //   })
    // })
    await performFetch(state.auth.api_url, {
      command: "update_user_layout",
      parameters: {
        application_token: state.auth.app_token,
        session_token: state.auth.token,
        layout: current_layout
      }
    })
      .then(async response => {
        if (response.status === 200) {
          response.json().then(async response => {
            // localStorage.setItem('layout', JSON.stringify(response.message))
            // commit('auth/SET_LAYOUT', response.message)
            // router.push('/dashboard/analytics')
          });
        } else if (response.status == 401) {
          setApplicationLocalStorageItem(
            "lastUrl",
            btoa(window.location.pathname)
          );
          dispatch("auth/signOut");
        } else {
          // $vs.notify({
          //   title: 'Operation Not Performed',
          //   text: 'An error occurred while updating the User',
          //   iconPack: 'feather',
          //   icon: 'icon-alert-circle',
          //   color: 'danger'
          // })
          // setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
          // dispatch('auth/signOut')
        }
      })
      .catch(e => {
        setApplicationLocalStorageItem(
          "lastUrl",
          btoa(window.location.pathname)
        );
        dispatch("auth/signOut");
        throw new Error(e.message);
      });
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit("UPDATE_USER_INFO", payload);
  },
  updateUserRole({ dispatch }, payload) {
    // Change client side
    payload.aclChangeRole(payload.userRole);

    // Make API call to server for changing role

    // Change userInfo in localStorage and store
    dispatch("updateUserInfo", { userRole: payload.userRole });
  }
};

export default actions;
